import { WorkawareApi } from 'apis/WorkawareApi'
import { ParticipationDashboardByEmployeeRecordRequest } from 'data/models/ParticipationDashboardByEmployeeRecordRequest'
import { ParticipationDashboardByFormDateRequest } from 'data/models/ParticipationDashboardByFormDateRequest'
import { ParticipationDashboardByEmployeeRecordData } from 'data/models/ParticipationDashboardByEmployeeRecordData'
import { ParticipationDashboardByFormDateData } from 'data/models/ParticipationDashboardByFormDateData'

export class ParticipationDashboardService{
    private _api: WorkawareApi

  constructor(api: WorkawareApi) {
    this._api = api
  }
  getByDate = (payload: ParticipationDashboardByFormDateRequest) => {
    return new Promise<ParticipationDashboardByFormDateData[]>((resolve, reject) => {
      this._api.ParticipationDashboard.getByDate(payload)
        .then((result) => resolve(result as ParticipationDashboardByFormDateData[]))
        .catch((error) => reject(error))
    })
  }

  getByEmployeeRecord = (payload: ParticipationDashboardByEmployeeRecordRequest) => {
    return new Promise<ParticipationDashboardByEmployeeRecordData[]>((resolve, reject) => {
      this._api.ParticipationDashboard.getByEmployeeRecord(payload)
        .then((result) => resolve(result as ParticipationDashboardByEmployeeRecordData[]))
        .catch((error) => reject(error))
    })
  }
}